import React, { useEffect } from "react";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogHeader,
    AlertDialogTitle,
} from "../../../../components/ui/AlertDialog";
import { AlertTriangle } from "lucide-react";

interface SkipQuestionDialogProps {
    isOpen: boolean;
    onClose?: () => void;
    onOpenChange: (open: boolean) => void;
    onSkipConfirmed?: () => void;
}

const SkipQuestionDialog = ({
    isOpen,
    onClose,
    onOpenChange,
    onSkipConfirmed,
}: SkipQuestionDialogProps) => {
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                onOpenChange(false);
                if (onSkipConfirmed) onSkipConfirmed();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [isOpen, onOpenChange, onSkipConfirmed]);

    return (
        <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2 text-yellow-700">
                        <AlertTriangle className="h-5 w-5" />
                        <span>Warning: Question Skip</span>
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-base space-y-2">
                        <p className="text-yellow-700 font-medium">
                            It's generally better to keep trying even if you get
                            stuck.
                        </p>
                        <p className="text-gray-600">
                            Skipping questions will impact your final score and
                            ranking in the report.
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default SkipQuestionDialog;
